import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo
}
    from 'devextreme-react/data-grid'; //npm install devextreme@19.1 devextreme-react@19.1
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { Component } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams } from '../../helpers/globalfunctions.js';
import { LoadPanel } from 'devextreme-react/load-panel';
import { RatesHistoryComponent } from '../Shared/RatesHistoryComponent';

const position = { of: '#historydiv' };

export class ZonalRatesComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowId: 0,
            addEditZonalRateDataModalIsOpen: false,
            isSubmited: false,
            customerList: [],
            customerId: 0,
            vehicleTypeList: [],
            vehicleTypeId: 0,
            isArrival: false,
            isDeparture: false,
            isAirporttoAirport: false,
            isLocationToLocation: false,
            isReturnLocationToLocation: false,
            zonalRatesList: null,
            loadPanelVisible: false,
        }
        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
        this.handleSearchZonalRateSubmit = this.handleSearchZonalRateSubmit.bind(this);
        this.handleAddEditZonalRateSubmit = this.handleAddEditZonalRateSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }
    async componentDidMount() {
        this.setState({
            loadPanelVisible: true,
        });
        await this.getcustomerList();
        await this.getvehicleTypeList();
        await this.getZonalRatesList();
        if (this.props.location.state != undefined) {

            this.setState({
                customerId: this.props.location.state.customerId,
                vehicleTypeId: this.props.location.state.vehicleTypeId,
                isArrival: this.props.location.state.isArrival,
                isDeparture: this.props.location.state.isDeparture,
                isAirporttoAirport: this.props.location.state.isAirporttoAirport,
                isLocationToLocation: this.props.location.state.isLocationToLocation,
                isReturnLocationToLocation: this.props.location.state.isReturnLocationToLocation,

            });

            let myVar = setTimeout(() => this.getZonalRatesList(), 200)
        }
        this.setState({
            loadPanelVisible: false,
        });
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'refresh',
                onClick: this.getZonalRatesList()
            }
        });
    }
    async getZonalRatesList() {
        var request = new Object();
        request.ApiVehicleTypeId = this.state.vehicleTypeId;
        request.CustomerId = this.state.customerId;

        var tripTypeId = ''
        if (this.state.isArrival) {
            tripTypeId += "1,"
        }
        if (this.state.isDeparture) {
            tripTypeId += "2,"
        }
        if (this.state.isAirporttoAirport) {
            tripTypeId += "3,"
        }
        if (this.state.isLocationToLocation) {
            tripTypeId += "13,"
        }
        if (this.state.isReturnLocationToLocation) {
            tripTypeId += "14,"
        }
        request.TripTypeId = tripTypeId;
        this.setState({
            isSubmited: true,
        });
        const requestParams = getRequestParams('POST', request);
        const response = await fetch('zonal-rate-api/list', requestParams);
        const data = await response.json();
        this.setState({
            zonalRatesList: data.zonalRateList
        });

        this.setState({
            isSubmited: false,
        });
    }
    async getcustomerList() {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('account-api/customer-dropdown/', requestParams);
        const data = await response.json();
        this.setState({
            customerList: data.customers.filter(x => x.rateTypeId === 1 || x.rateTypeId === 5),
        });

    }
    handleCustomerInputChange = (data) => {
        this.setState({ customerId: (data.selectedItem != null ? data.selectedItem.id : 0), })
    }

    async getvehicleTypeList() {
        var newObject = new Object();
        newObject.LocationId = parseInt(sessionStorage.getItem("session_locationId"));
        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('vehicletype-api/vehicletype', requestParams);
        const data = await response.json();

        this.setState({
            vehicleTypeList: data.apiVehicleType
        });
    }
    handleVehicleTypeInputChange = (data) => {
        this.setState({ vehicleTypeId: (data != null ? data.rowIndex : 0), })
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    async handleSearchZonalRateSubmit(e) {
        e.preventDefault();

        await this.getZonalRatesList();
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            customerId: 0,
            vehicleTypeId: 0,
            isArrival: false,
            isDeparture: false,
            isAirporttoAirport: false,
            isLocationToLocation: false,
            isReturnLocationToLocation: false,
        });

       let myVar =  setTimeout(() =>  this.getZonalRatesList(), 200)
    }

    addEditZonalRatesControl(e, data) {
        e.preventDefault();
        
        if (data == null) {
            this.props.history.push({
                pathname: '/zonalrate/details',
                //state: { detail: data }
                state: {
                    isAdd: true
                    , customerId: this.state.customerId
                    , rideTypeId: 0
                    , fromAirportId: 0
                    , toAirportId: 0
                    , fromZoneId: 0
                    , toZoneId: 0
                    , vehicleTypeId: this.state.vehicleTypeId
                    , isArrival: this.state.isArrival
                    , isDeparture: this.state.isDeparture
                    , isAirporttoAirport: this.state.isAirporttoAirport
                    , isLocationToLocation: this.state.isLocationToLocation
                    , isReturnLocationToLocation: this.state.isReturnLocationToLocation
                    , sourceUrl: "/zonalrate/list"
                    , sourceState: this.state
                }
            })
        } else {
            this.props.history.push({
                pathname: '/zonalrate/details',
                //state: { detail: data }
                state: {
                    isAdd: false
                    , customerId: data.customerId
                    , rideTypeId: data.rideTypeId
                    , fromAirportId: data.fromAirportId
                    , toAirportId: data.toAirportId
                    , fromZoneId: data.fromZoneId
                    , toZoneId: data.toZoneId
                    , vehicleTypeId: this.state.vehicleTypeId
                    , isArrival: this.state.isArrival
                    , isDeparture: this.state.isDeparture
                    , isAirporttoAirport: this.state.isAirporttoAirport
                    , isLocationToLocation: this.state.isLocationToLocation
                    , isReturnLocationToLocation: this.state.isReturnLocationToLocation
                    , sourceUrl: "/zonalrate/list"
                    , sourceState: this.state
                }
            })
        }
        
    }

   
    zonalRatesHistoryControl = (e, data) => {
        e.preventDefault();

        var fromZoneIdStr = (data.rideTypeId == 1 || data.rideTypeId == 3) ? data.fromAirportId : data.fromZoneId;
        var toZoneIdStr = (data.rideTypeId == 2 || data.rideTypeId == 3) ? data.toAirportId : data.toZoneId;
        this.refs.ratesHistoryComponent.showModal("Zonal Rate History",data.customerId, fromZoneIdStr, toZoneIdStr);
    }
    openZonalRateDataModal = () => { }
    async handleAddEditZonalRateSubmit(e) {
        e.preventDefault();
    }
    closeaddEditZonalRateModal = () => {
        this.setState({
            rowId: 0,
            isSubmited: false,
            addEditZonalRateDataModalIsOpen: false
        });
        this.getZonalRatesList();
    }

    render() {
        const serviceAreaModalTitle = this.state.rowId > 0 ? "Edit Zonal Rate" : "Add Zonal Rate"
        const renderEditGridCell = (data) => {
            return <div>&nbsp;&nbsp;
                <a href="#" className="fas fa-pen icon text-info" title="Edit" onClick={(e) => { this.addEditZonalRatesControl(e, data.data) }} ></a>&nbsp;&nbsp;
                <a href="#" className="fas fa-history icon text-info" title="History" onClick={(e) => { this.zonalRatesHistoryControl(e, data.data) }} ></a>&nbsp;&nbsp;
            </div>;
        }
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-sm-6 col-md-6 col-lg-6">
                                <h1 className="m-0 text-dark">Zonal Rates</h1>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <ol className="breadcrumb float-sm-right">
                                    <NavItem>
                                        <NavLink tag={Link} to="#" onClick={(e) => { this.addEditZonalRatesControl(e, null) }} className="btn btn-block btn-outline-secondary btn-sm" title="Add Zonal Rate" ><i className="fas fa-plus"></i> Add Zonal Rate</NavLink>
                                    </NavItem>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <form method="post" onSubmit={this.handleSearchZonalRateSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                    <div className="rez-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label>Customer</label>
                                        <SelectBox
                                            dataSource={this.state.customerList.length > 0 ? this.state.customerList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer"
                                            name="customerId"
                                            defaultValue={0}
                                            value={this.state.customerId}
                                            displayExpr='fullName'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleCustomerInputChange}
                                            showClearButton={true}
                                            disabled={this.state.isSearched == true}
                                            searchEnabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label>Vehicle</label>
                                        <SelectBox
                                            dataSource={this.state.vehicleTypeList.length > 0 ? this.state.vehicleTypeList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select vehicle type"
                                            name="vehicleTypeId"
                                            defaultValue={0}
                                            value={this.state.vehicleTypeId}
                                            displayExpr='apiVehicleTypeDescription'
                                            valueExpr='rowIndex'
                                            onSelectionChanged={this.handleVehicleTypeInputChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" style={{ paddingTop: 22 + 'px' }}>
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp;</label>
                                        <span className="form-check">
                                            <input className="form-check-input" type="checkbox" name="isArrival" checked={this.state.isArrival} onChange={this.handleInputChange} />
                                            <label className="form-check-label">Arrival</label>
                                        </span>
                                        <span className="form-check ml-3">
                                            <input className="form-check-input" type="checkbox" name="isDeparture" checked={this.state.isDeparture} onChange={this.handleInputChange} />
                                            <label className="form-check-label">Departure</label>
                                        </span>
                                        <span className="form-check ml-3">
                                            <input className="form-check-input" type="checkbox" name="isAirporttoAirport" checked={this.state.isAirporttoAirport} onChange={this.handleInputChange} />
                                            <label className="form-check-label">Airport to Airport</label>
                                        </span>
                                        <span className="form-check ml-3">
                                            <input className="form-check-input" type="checkbox" name="isLocationToLocation" checked={this.state.isLocationToLocation} onChange={this.handleInputChange} />
                                            <label className="form-check-label">Location to Location</label>
                                        </span>
                                        <span className="form-check ml-3">
                                            <input className="form-check-input" type="checkbox" name="isReturnLocationToLocation" checked={this.state.isReturnLocationToLocation} onChange={this.handleInputChange} />
                                            <label className="form-check-label">Return - Location to Location</label>
                                        </span>

                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-right">
                                    <div className="form-group">
                                        <label className="btn-block">&nbsp;</label>
                                        <button type="submit" className="btn btn-success btn-sm" onClick={this.handleSearchZonalRateSubmit} >
                                            {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                            {!this.state.isSubmited && <span title="Search"><i className="fas fa-search"></i> Search</span>}
                                        </button>&nbsp; &nbsp;
                                             <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleClearSearch} title="Clear"><i className="fas fa-eraser"></i> Clear</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                    <div className="content">
                        <div className="card">
                            <div className="card-body">
                                <DataGrid
                                    dataSource={this.state.zonalRatesList}
                                    keyExpr="rowId"
                                    selection={{ mode: 'single' }}
                                    columnsAutoWidth={false}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={true}
                                    rowAlternationEnabled={true}
                                    showBorders={true}
                                    allowColumnResizing={true}
                                    columnResizingMode='widget'
                                    width='100%'
                                    onToolbarPreparing={this.onToolbarPreparing}>
                                    <Column dataField="accountId" width={50} caption="" allowFiltering={false} allowSorting={false} cellRender={renderEditGridCell} />
                                    <Column dataField="customerName" caption="Customer Name" allowFiltering={true} allowSorting={true} />
                                    <Column dataField="rideType" caption="Ride Type" allowFiltering={true} allowSorting={true} />
                                    <Column dataField="startZone" caption="Start Zone"/>
                                    <Column dataField="endZone" caption="End Zone"/>
                                    <SortByGroupSummaryInfo summaryItem="count" />
                                    <GroupPanel visible={true} />
                                    <HeaderFilter visible={false} />
                                    <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                    <Grouping autoExpandAll={true} />
                                    <Paging defaultPageSize={20} />
                                    <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={true} visible={true}/>
                                    <Export enabled={true} allowExportSelectedData={false} />
                                    <ColumnChooser enabled={true} />
                                    <ColumnFixing enabled={true} />
                                </DataGrid>
                            </div>
                        </div>

                    </div>
              
                <Modal ariaHideApp={false}
                    isOpen={this.state.addEditZonalRateDataModalIsOpen}
                    className={"react-modal edit-service-modal"}
                    onAfterOpen={this.openZonalRateDataModal}
                    onRequestClose={this.closeaddEditZonalRateModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <form method="post" onSubmit={this.handleAddEditZonalRateSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">{serviceAreaModalTitle}</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeaddEditZonalRateModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <label>Location <span className="text-red">*</span></label>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success btn-sm" onClick={this.handleAddEditZonalRateSubmit} >
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Save"><i className="fas fa-save"></i> Save</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.closeaddEditZonalRateModal} title="Close"><i className="fas fa-times"></i> Close</button>
                        </div>
                    </form>
                </Modal>
                <RatesHistoryComponent ref="ratesHistoryComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >)
    }
}